export let V = Object.freeze({
    //SERVER: "http://localhost:1025", // LOCAL
    //SERVER: "https://y0brxipd2d.execute-api.us-west-1.amazonaws.com/latest", // TEST
    SERVER: "https://8upvsokftb.execute-api.us-west-1.amazonaws.com/latest", // PROD
    CURRENT_VERSION: "1.34.2",
    CLIENT_SERVER: "https://dbmenos.com", // LOCAL
    CONSULTANT_IMG_PATH: "/img/consultants",
    SIGNATURE_PATH: "/signature",
    STORE_KEYS: {
        GENERAL_INFO: "generalInfo",
        BANKS: "banks",
        SESSION: "session",
        USER: "user",
        SET_SHOW_LOADER: "setShowLoader"
    },
    OPS: {
        INSERT: "/dbm/insert/",
        UPDATE: "/dbm/update/",
        SELECT: "/dbm/select/",
        DELETE: "/dbm/delete/",
        CALCULATE: "/dbm/calculate",
        LOGIN: "/usr/login",
        SIGNUP: "/usr/signup",
        LINK_ACCOUNT: "/usr/linkacc",
        UPLOAD_PAYMENT: "/dbm/uploadpayment",
        UPLOAD_FILE: "/dbm/uploadfile",
        GET_USER_FILE: "/dbm/getfile",
        VERIFY_SESSION: "/dbm/validatesess",
        VALIDATE_LEAD_SMS_CODE: "/dbm/validate_lead_sms_code",
        GET_MX_STATES: "/dbm/getstates",
        GET_TRACING_STATUS: "/dbm/getTracingStatus",
        GET_RFC_CURP: "/dbm/getrfccurp",
        GET_POSTAL_CODE: "/dbm/getpostalcode",
        GET_FINAMIGO_BALANCE: "/slr/getFinamigoBalance",
        GET_USER_FINAMIGO_FILES: "/slr/getUserFinamigoFiles"
    },
    ADMIN_OPS: {
        DELETE_ACCOUNT: "/adm/del/account",
        SET_CONSULTANT: "/adm/set_consultant",
        SET_BLOG_ENTRY: "/adm/setBlogEntry",
        REMOVE_BLOG_ENTRY: "/adm/RemoveBlogEntry",
        GET_BLOG_ENTRY: "/api/blogEntry",
        GET_BLOG_ENTRIES: "/api/blogEntries",
        GET_USER_HISTORY: "/adm/getUserHistory",
        GET_NEW_USER_LIST: "/adm/getNewUserList",
        UPLOAD_CSV: "/adm/uploadCSV",
        APPLY_COMMISSIONS_CSV: "/adm/applyCommissionsCSV"
    },
    SELLER_OPS: {
        SEND_MASSIVE_PUSH_NOTIFICATION: "/slr/sendMassivePushNotification",
        SEND_PUSH_NOTIFICATION: "/slr/sendPushNotification",
        GET_USER_HISTORY: "/slr/getUserHistory",
        GET_USER_HISTORY_EVENTS: "/slr/getUserHistoryEvents",
        CREATE_FINAMIGO_DOCUMENTS: '/slr/createFinamigoDocuments',
        UPDATE_CREDIT_REPORT: '/slr/updateCreditReport',
        SEND_MESSAGE: "/slr/sendSMS",
        VALIDATE_SESSION: "/dbm/validatesess",
        GET_CONSULTANTS: "/slr/getConsultants",
        LOGIN: "/slr/login",
        GET_GENERAL_INFO: "/slr/getGeneralInformation",
        GET_PROFILE: "/slr/getProfile",
        GET_PROFILES: "/slr/getProfiles",
        GET_LEADS: "/slr/getLeads",
        ASSIGN_LEAD: "/slr/assignLead",
        SET_SELL_TRACING: "/slr/setSellTracing",
        GET_SELL_TRACING: "/slr/getSellTracing",
        GET_USER_FIELDS: "/slr/getUserFields",
        UPDATE_USER: "/slr/updateUser",
        GET_USER_FILES: "/slr/getUserFiles",
        GET_USER_FILE: "/slr/getUserFile",
        GET_USER_PAYMENT_FILE: "/slr/getUserPaymentFile",
        UPDATE_PAYMENT: "/slr/updatePayment",
        CREATE_COMMISSION: "/slr/createCommission",
        UPDATE_COMMISSION: "/slr/updateCommission",
        UPDATE_BENEFICIARY: "/slr/updateBeneficiary",
        GET_BENEFICIARY: "/slr/getBeneficiary",
        UPLOAD_FILE: "/slr/uploadFile",
        UPLOAD_PAYMENT: "/slr/uploadPayment",
        GET_FUTURE_ACCOUNTS: "/slr/getFutureAccounts",
        UPDATE_ACCOUNTS: "/slr/updateAccounts",
        CREATE_CONTRACT: "/slr/createContract",
        REQUEST_CREDIT_REPORT: "/slr/requestCreditReport",
        REQUEST_CREDIT_REPORT_PIN: "/slr/requestCreditReportPin",
        VALIDATE_CREDIT_REPORT_PIN: "/slr/validateCreditReportPin",
        CREATE_SIGNATURE_TOKEN: "/slr/createSignatureToken",
        CREATE_FINAMIGO_ACCOUNT: "/slr/createFinamigoAccount",
        UPLOAD_FINAMIGO_DOCUMENTS: "/slr/uploadFinamigoDocuments",
        RESET_USER_PASSWORD: "/slr/resetUserPassword",
        UPDATE_USER_PAYMENT_STATUS: "/slr/updatePaymentStatus",
        CREATE_DBM_CONTRACT: "/slr/createDBMContract",
        GET_PRESIGNED_PUT_OBJECT_URL: "/slr/getPresignedPutS3ObjectUrl",
        REQUEST_ACCOUNT_SIGN: "/slr/requestAccountSign",
        UPLOAD_FILE_FINAMIGO: "/slr/uploadFinamigoFiles",
        GET_PROGRAM_CALCULATION: "/slr/programCalculation",
        GET_USER_FROM_LEAD: "/slr/getUserFromLead",
        GET_WHATSAPP_CONTACTS: "/slr/getWhatsAppContacts",
        GET_WHATSAPP_CHAT: "/slr/getWhatsAppChats",
    },
    SERVICE_OPS: {
        GET_USER_MOVEMENTS: "/srv/getUserMovements",
        SET_PAID_ACCOUNT: "/srv/setPaidAccount",
        GET_MASSIVE_CREDIT_REPORT: "/slr/getCreditReports",
        GET_USER_TRACING: "/srv/getUserTracing",
        SET_USER_TRACING: "/srv/setUserTracing",
        GET_EDITABLE_ACCOUNTS: "/slr/getEditableAccounts",
        GET_MASSIVE_COMMISSIONS: "/slr/getMassiveCommissions",
        GET_MASSIVE_BALANCES: "/slr/getMassiveFinamigoAccounts",
        GET_CREDIT_REPORT: '/slr/getCreditReport',
        GET_SERVICE_EVENTS: "/srv/getServiceEvents"
    },
    CONSULTANT_OPS: {
        GET_CLIENTS_TO_MANAGER: '/cst/getClientsToManager',
        ASSIGN_USER_SERVICE: '/cst/assignUserToService',
        AUTO_ASSIGN_USER: '/cst/autoAssignUser',
        SET_USER_ACTION: '/cst/setUserAction',
        GET_USER_ACTIONS: '/cst/getUserAction',
        GET_INACTIVE_CATALOG: '/cst/getInactiveCatalog',
        SET_INACTIVE_USER: '/cst/setInactiveUser',
        GET_INACTIVE_USER: '/cst/getInactiveUser',
        GET_USER_ACTIONS_CATALOG: '/cst/getUserActionCatalog',
        GET_NEW_USER_LIST: "/cst/getNewUserList",
        GET_PROJECTIONS: '/cst/getProjections',
        SET_PROJECTION: '/cst/setProjection',
    },
    FINAMIGO_OPS: {
        GET_ACCOUNTS: '/fna/getAccounts',
        GET_FILE_URL: '/fna/getUserFile'
    },
    STADISTICS_OPS: {
    GET_V_ACTIVE_ACCOUNTS_PER_BANK: "/slr/vActiveAccountsPerBank",
    GET_V_ACTIVE_ACCOUNTS_TOTAL: "/slr/vActiveAccountsTotal",
    GET_V_ACTIVE_CLIENTS: "/slr/vActiveClients",
    GET_V_ACTIVE_CLIENTS_GRAPHICS: "/slr/vActiveClientsGraphics",
    GET_V_AMOUNT_ENTERED: "/slr/vAmountEntered",
    GET_V_CIERRES: "/slr/vCierres",
    GET_V_CLIENTS_PER_STATE: "/slr/vClients_per_state",
    GET_V_COMMISSIONS: "/slr/vCommissions",
    GET_V_COMMISSIONS_GRAPHICS: "/slr/vCommissionsGraphics",
    GET_V_CONSULTANTS_INFO: "/slr/vConsultantsInfo",
    GET_V_CONTRACTS_INFO: "/slr/vContractsInfo",
    GET_V_GRADUATES: "/slr/vGraduates",
    GET_V_GRADUATION_DATE: "/slr/vGraduationDate",
    GET_V_HISTORY_EVENTS_PER_DEVICE: "/slr/VHistoryEventsPerDevice",
    GET_V_INFO_LEVEL: "/slr/vInfoLevel",
    GET_v_LAST_PAYMENT: "/slr/vLastPayment",
    GET_V_LEVEL_COUNT: "/slr/vLevelCount",
    GET_V_MARKETING_ORIGIN: "/slr/vMarketingOrigin",
    GET_V_MONTH_INFO: "/slr/vMonthInfo",
    GET_V_NEW_CLIENTS_STATS: "/slr/vNewClientStats",
    GET_V_PAYMENTS_PER_ACTIVE_CLIENT: "/slr/vPaymentsPerActiveClient",
    GET_V_REGISTER_INFO: "/slr/vRegisterInfo",
    GET_V_SETTLEMENTS: "/slr/vSettlements",
    GET_V_TOTAL_GRADUATES: "/slr/vTotalGraduates",
    },
    TABLES: {
        ACCOUNTS: "accounts",
        ACCOUNTS_TRACE_STATUS: "account_trace_status",
        ACCOUNTS_TRACING: "account_tracing",
        BANKS: "banks",
        ECONOMIC_ACTIVITIES: "economic_activities",
        CLIENTS: "clients",
        DEFS: "defs",
        FINAMIGO: "finamigo",
        FUTURE_ACCOUNTS: "future_accounts",
        LEADS: "leads",
        LEADS_STATUS: "leads_status",
        USER_TRACE_STATUS: "user_trace_status",
        USER_TRACING: "user_tracing",
        MARKETING_LEADS: "marketing_leads",
        PAYMENTS: "payments",
        COMMISSIONS: "commissions",
        SESSIONS: "sessions",
        USER_FILES: "user_files",
        USERS: "users"
    },
    VIEWS: {
        PROFILE: "profile"
    },
    TERMS_CONDITIONS: "https://s3-us-west-1.amazonaws.com/dbmenos/documentos/TERMINOS+Y+CONDICIONES+GRUPO+DB+MENOS+2018.pdf",
    PRIVACY_NOTICE: "https://s3-us-west-1.amazonaws.com/dbmenos/documentos/AVISO+DE+PRIVACIDAD+GRUPO+DB+MENOS+2018.pdf",
    FACEBOOK_PIXEL_ID: "175290776628728",
    API_SUCCESS: "success",
    API_ROWS: "rows",
    API_ROW: "row",
    API_REASON: "reason",
    SESSION: "session",
    USER: "user",
    ROUTES: {
        DASHBOARD: "/dashboard",
        LEADS: "/leads",
        CLIENTS: "/clients",
        CLIENT: "/client",
        FINAMIGO: "/finamigoView"
    },
    ROLES: {
        ADMIN: "admin",
        MANAGER_SERVICE: "manager_service",
        MANAGER_SELLER: "manager_seller",
        USER: "user",
        SELLER: "seller",
        SERVICE: "service",
        FINAMIGO: "finamigo"
    },
    OBJECTS: {
        USER: {
            id: null,
            name: null,
            lastname_1: null,
            lastname_2: null,
            birthday: null,
            email: null,
            phone: null,
            id_number: null,
            curp: null,
            rfc: null,
            addr_postal_code: null,
            addr_street: null,
            addr_extnum: null,
            addr_intnum: null,
            addr_sublocality: null,
            gender: null,
            state_of_birth: null,
            consultant: null,
            economic_activity: null,
            civil_status: null
        },
        CONTRACT: {
            user: null,
            filename: null,
            completed: null,
            payday_1: null,
            payday: null,
            program_duration: null,
            monthly_savings: null,
            program_status: null,
            signature: null
        },

    }
})
